/**
 * @fileoverview Home page component.
 * @summary Landing page with role selection (organizer or singer).
 *
 * @package KaraoNow
 * @module apps/front/src/pages/HomePage
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useRoleBasedRedirect } from '../hooks/useRoleBasedRedirect.js'

/**
 * @summary Home page component.
 * @returns {React.ReactElement} Home page.
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
export default function HomePage() {
  const { t } = useTranslation()

  // Redirect authenticated users based on their role
  useRoleBasedRedirect()

  return (
    <div className="min-h-screen flex pt-2 justify-center  ">
      <div className="w-full page-container-large opacity-95">
        <div className="card">
          <div className="text-center mb-5">
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gradient">
              🎤 KaraoNow
            </h2>
            <p className="text-lg sm:text-xl text-(--color-text-secondary) mt-2">
              {t('home.title')}
            </p>
          </div>

          <div className="space-y-4 mb-5">
            <Link
              to="/register?role=singer"
              className="block w-full"
            >
              <div className="card hover:shadow-lg transition-shadow cursor-pointer card-singer">
                <div className="text-center">
                  <div className="text-4xl mb-2">🎤</div>
                  <h3 className="text-xl font-bold text-(--color-text-primary) mb-2">{t('home.wantToSing')}</h3>
                  <p className="text-sm text-(--color-text-secondary)">
                    {t('home.wantToSingDescription')}
                  </p>
                </div>
              </div>
            </Link>

            <Link
              to="/register?role=organizer"
              className="block w-full"
            >
              <div className="card hover:shadow-lg transition-shadow cursor-pointer card-organizer">
                <div className="text-center">
                  <div className="text-4xl mb-3">🎛️</div>
                  <h3 className="text-xl font-bold text-(--color-text-primary) mb-2">{t('home.wantToOrganize')}</h3>
                  <p className="text-sm text-(--color-text-secondary)">
                    {t('home.wantToOrganizeDescription')}
                  </p>
                </div>
              </div>
            </Link>
          </div>

          <div className="text-center pt-4 border-t border-(--color-text-tertiary)">
            <p className="text-sm text-(--color-text-tertiary) mb-3 pt-4!">
              {t('home.alreadyHaveAccount')}
            </p>
            <Link
              to="/login"
              className="btn btn-primary btn-lg w-full "
            >
              {t('auth.login')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
